module.exports = __webpack_public_path__ + "img/barcode-example.b24a9729.png";